import Udesk from '../../../../common';
import Component from './template';

export default Udesk.react.udeskify(Component);